/** A load that failed (design v2 § 9): what happened, that nothing is lost, Try again, and
 * the code and service in mono so a report can say which one. */
import type { ApiFailure } from "../api/client";

export function LoadError({ failure, onRetry }: { failure: ApiFailure; onRetry: () => void }) {
  const code = failure.status === 0 ? "no connection" : `error ${failure.status}`;
  return (
    <section className="load-error" role="alert" aria-labelledby="load-error-title">
      <h2 id="load-error-title" className="load-error__title">
        That didn’t load
      </h2>
      <p className="load-error__text">
        Check your connection and try again. Nothing you made has been lost.
      </p>
      <div className="load-error__actions">
        <button type="button" className="button" onClick={onRetry}>
          Try again
        </button>
        <code className="load-error__code">
          {failure.service ? `${code} · ${failure.service}` : code}
        </code>
      </div>
    </section>
  );
}
